import React from "react";
import { Modal, Button, Table } from "react-bootstrap";

const StatusModal = ({
  show,
  handleClose,
  bomList = {},
  selectedBOM,
  batchSize,
}) => {
  const parseBatchSize = (batchSize) =>
    parseFloat(batchSize?.toString().replace(/[^\d.]/g, "")) || 0;

  const numericBatchSize = parseBatchSize(batchSize);

  const getStatusColor = (status) =>
    status === "Not Available" ? "text-danger" : "text-success";

  // Extract relevant data
  const rawMaterials =
    bomList.raw_materials?.filter((bom) => bom.id === selectedBOM) || [];
  const finishedGoods =
    bomList.finished_goods?.filter((bom) => bom.id === selectedBOM) || [];
  const consumableItems =
    bomList.consumable_items?.filter((bom) => bom.id === selectedBOM) || [];

  // Common Table Component
  const renderTable = (title, data, itemKeys) => (
    <>
      <h5 className="mt-3">{title}</h5>
      {data.length > 0 ? (
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>BOM Name</th>
              <th>Item Name</th>
              <th>Available Qty</th>
              <th>Qty</th>
              <th>Final Qty</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr key={index}>
                <td>{item.bom_name}</td>
                <td>{item[itemKeys.item_name]}</td>
                <td>
                  {item[itemKeys.available_stock]
                    ? item[itemKeys.available_stock]
                    : "Not Available"}
                </td>
                <td>{item[itemKeys.qty]}</td>
                <td>
                  {(
                    (numericBatchSize * (parseFloat(item[itemKeys.qty]) || 0)) /
                    100
                  ).toFixed(4)}
                </td>
                <td className={getStatusColor(item[itemKeys.status])}>
                  {item[itemKeys.status]}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <Table striped bordered hover responsive>
          <tbody>
            <tr>
              <td colSpan="6" className="text-center text-muted py-3">
                No data available
              </td>
            </tr>
          </tbody>
        </Table>
      )}
    </>
  );

  return (
    <Modal show={show} onHide={handleClose} size="xl">
      <Modal.Header closeButton>
        <Modal.Title>Status Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* Raw Materials */}
        {renderTable("Raw Materials", rawMaterials, {
          item_name: "item_name",
          available_stock: "available_stock",
          qty: "qty",
          status: "status",
        })}

        {/* Finished Goods */}
        {renderTable("Finished Goods", finishedGoods, {
          item_name: "fg_item_name",
          available_stock: "fg_available_stock",
          qty: "fg_qty",
          status: "fg_status",
        })}

        {/* Consumable Items */}
        {renderTable("Consumable Items", consumableItems, {
          item_name: "ci_item_name",
          available_stock: "ci_available_stock",
          qty: "ci_qty",
          status: "ci_status",
        })}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default StatusModal;
